module.exports = __webpack_public_path__ + "static/media/the_fight_for_food_security_tablet.f1ba2e09.jpg";